
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    name: 'ire-v2-filter',
    emit: ['ire-v2-type-selected', 'reset'],
    components: {
      Multiselect,
    },
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        areaId: '',
      });

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        emit('ire-v2-type-selected', selectedItems);
      };
      const onReset = () => {
        selectedItems.value = {
          areaId: '',
        };
        emit('reset', selectedItems.value);
      };

      await store.dispatch(Actions.GET_ALL_IRE_V2_AREAS);

      reinitializeComponents();

      return {
        areas: computed(() => store.getters.ireV2AreasAllList),
        onSubmit,
        onReset,
        translate,
        selectedItems,
      };
    },
  });
